import { Container, Typography, Box, Grid } from '@mui/material';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 6 }}>
        About Aquamire
      </Typography>
      
      <Grid container spacing={6} alignItems="center" sx={{ mb: 8 }}>
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Box
              component="img"
              src="/about-office.jpg"
              alt="Aquamire Office"
              sx={{ width: '100%', borderRadius: 2, boxShadow: 3 }}
            />
          </motion.div>
        </Grid>
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
              Our Mission
            </Typography>
            <Typography variant="body1" paragraph sx={{ mb: 2 }}>
              Aquamire was founded to provide investors with access to the attractive economics of private market managers through GP stakes investments.
            </Typography>
            <Typography variant="body1" paragraph sx={{ mb: 2 }}>
              We believe that by acquiring minority positions in top-tier alternative asset managers, we can deliver consistent cash flows and attractive upside potential to our investors.
            </Typography>
            <Typography variant="body1" paragraph>
              Our team combines deep expertise in private markets with specialized knowledge of GP stakes investing to identify and partner with the most promising managers.
            </Typography>
          </motion.div>
        </Grid>
      </Grid>

      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Our History
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 2 }}>
          Founded in 2018, Aquamire has grown to become a respected investor in GP stakes with a portfolio spanning real estate, private equity, and private credit strategies.
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 2 }}>
          Our first fund, raised with $20 million from several family offices, has been tracking net returns north of 25% and continues to deliver strong performance.
        </Typography>
        <Typography variant="body1" paragraph>
          Today, we manage a diversified portfolio of GP stakes investments and continue to seek opportunities to partner with exceptional private market managers.
        </Typography>
      </Box>

      <Box sx={{ backgroundColor: '#f5f7fa', p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Investment Philosophy
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
              Discipline
            </Typography>
            <Typography variant="body1">
              We maintain strict investment criteria and only partner with managers who demonstrate consistent performance across market cycles.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
              Alignment
            </Typography>
            <Typography variant="body1">
              We seek managers with strong alignment between the firm and its investors, including meaningful GP commitments.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
              Value Creation
            </Typography>
            <Typography variant="body1">
              We actively work with our partner firms to help them scale their platforms and enhance their operations.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default About;
